export default [{ path: '/engine/guides', name: 'engine-guides', component: () => import('./GuideManager.vue'), meta: { engine: true, requiresAdmin: true } }]
